<template>
  <div v-if="type === 'text'" class="Uselectbox" @click="clickHandler">
    <div class="UselectBox_select" :class="(disable ? 'disable' : (line ? 'line' : 'base'))" :style="getStyle">
      <span v-html="selectText">{{ selectText }}</span>
      <span v-if="!isShow">∨</span>
      <span v-else>∧</span>
    </div>
    <ul class="UselectBox_list" v-if="isShow" :style="getListStyle">
      <li class="UselectBox_item" :class="[alignitem]" v-for="(option, index) in options" @click="selectHandler(option, index)" :key="index">
        <span :class="value == index ? 'select' : ''" :style="option.css" v-html="option.text">{{option.text}}</span>
      </li>
    </ul>
  </div>
  <div v-else-if="type === 'edit'" class="EditUselectbox" @click="clickHandler">
    <div class="EditUselectbox_select line" :style="getStyle">
      <span v-html="selectText">{{ selectText }}</span>
      <span v-if="!isShow">∨</span>
      <span v-else>∧</span>
    </div>
    <ul class="EditUselectbox_list" v-if="isShow" :style="getListStyle">
      <li class="EditUselectbox_item" :class="[alignitem]" v-for="(option, index) in options" @click="selectHandler(option, index)" :key="index">
        <span :class="value == index ? 'select' : ''" :style="option.css" v-html="option.text">{{option.text}}</span>
      </li>
    </ul>
  </div>
  <div v-else-if="type === 'noline'" class="Uselectbox" @click="clickHandler">
    <div class="UselectBox_select" :style="getStyle">
      <span v-html="selectText">{{ selectText }}</span>
      <span v-if="!isShow">▼</span>
      <span v-else>▲</span>
    </div>
    <ul class="UselectBox_list" v-if="isShow" :style="getListStyle">
      <li class="UselectBox_item" :class="[alignitem]" v-for="(option, index) in options" @click="selectHandler(option, index)" :key="index">
        <span :class="value == index ? 'select' : ''" :style="option.css" v-html="option.text">{{option.text}}</span>
      </li>
    </ul>
  </div>
  <div v-else-if="type === 'icon'" class="UselectBox" @click="clickHandler">
    <div class="UselectBox_select line" :style="getStyle">
      <icon size="xsmall" :icon="selectIcon"/>
    </div>
    <ul class="UselectBox_list" v-if="isShow" :style="getListStyle">
      <li class="UselectBox_item" :class="[alignitem]" v-for="(option, index) in options" @click="selectHandler(option, index)" :key="index">
        <icon size="xsmall" :icon="option.icon" :title="option.title"/>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {type: Number, default: 0},
    options: { type: Array },
    type: { type: String, default: 'text' },
    width: { type: Number },
    height: {type: Number},
    line: {type: Boolean, default: true},
    stepH: {type: Number},
    description: {type: String, default: ''},
    alignitem: {type: String, default: 'center'},
    display: {type: String, default: 'down'},
    disable: {type: Boolean, default: false}
  },
  data: function () {
    return {
      selectIndex: this.value,
      isShow: false
    }
  },
  name: 'Uselectbox',
  watch: {
    value (val) {
      if (this.selectIndex !== val) {
        console.log(this.selectIndex, val)
        this.selectIndex = val
      }
    }
  },
  computed: {
    selectText () {
      console.log(this.options)
      return (this.options !== null && this.options.length && this.value !== -1) ? this.options[this.value].text : this.description
    },
    selectIcon () {
      return (this.options !== null && this.options.length && this.value !== -1) ? this.options[this.value].icon : this.description
    },
    getStyle () {
      var ob = {}
      if (this.width) {
        ob.width = this.width.toString() + 'px'
      }
      if (this.height) {
        ob.height = this.height.toString() + 'px'
      }
      return ob
    },
    getListStyle () {
      var ob = {}
      if (this.width) {
        ob.width = this.width.toString() + 'px'
      }
      // if (this.height) {
      //   ob.height = this.height.toString() + 'px'
      // }
      if (this.display === 'up' && this.stepH) {
        ob.bottom = this.stepH.toString() + 'px'
      }
      return ob
    }
  },
  methods: {
    clickHandler (e) {
      console.log('clickHandler')
      if (this.options !== null && this.options.length && this.disable === false) {
        this.isShow = !this.isShow
        this.$root.$el.addEventListener('mouseup', this.mouseUp)
      }
    },
    mouseUp (e) {
      if (!this.isTarget(e, this.$el)) {
        this.isShow = false
      }
      this.$root.$el.removeEventListener('mouseup', this.mouseUp)
    },
    selectHandler (e, index) {
      this.$emit('input', index)
      this.$emit('selected', {prev: this.selectIndex, param: e, current: index})
      this.selectIndex = index
    }
  }
}
</script>

<style scoped>
.Uselectbox {
  position: relative;
  min-height: 25px;
  color: var(--text-title);
  /* flex: 1; */
}
.UselectBox_select {
  position: relative;
  min-height: 25px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* max-width: 500px; */
  cursor: pointer;
  box-sizing: border-box;
  background-color: var(--bg-base);
}
.UselectBox_select.disable {
  border: 1px solid var(--disable);
}
.UselectBox_select.line {
  border: 1px solid var(--line-base);
}
.UselectBox_select.line:hover {
  color: var(--bg-white);
  background-color: var(--text-base);
}
.UselectBox_select.base:hover {
  color: var(--bg-white);
  background-color: var(--text-base);
  border: 1px solid var(--line-base);
}
.UselectBox_select.base span + span, .UselectBox_select.line span + span {
  position: absolute;
  right: 5px;
  top: 45%;
  transform: translateY(-50%);
}
.UselectBox_select.border {
  border: 1px solid var(--line-base);
}
.UselectBox_list {
  width: 100%;
  max-height: 180px;
  background-color: var(--bg-white);
  border: 1px solid var(--line-base);
  overflow: auto;
  position: absolute;
  z-index: 5;
  /* max-width: 500px; */
  margin: 0;
  padding: 5px;
  box-sizing: border-box;
}
.UselectBox_item {
  width: 100%;
  display: grid;
  min-height: 24px;
  align-content: center;
  cursor: pointer;
  padding: 0px 10px;
}
.UselectBox_item.center {
  justify-content: center;
}
.UselectBox_item:last-child {
  border-bottom: none;
}
.UselectBox_item .select {
  color: var(--active);
}
.UselectBox_item:hover {
  color: var(--icon-over);
}

.EditUselectbox {
  height: 100%;
  min-height: 30px;
  max-height: 40px;
}
.EditUselectbox_select {
  height: 100%;
  /* background-color: var(--bg-white); */
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  cursor: pointer;
  box-sizing: border-box;
}
.EditUselectbox_select:hover {
  color: var(--active);
}
.EditUselectbox_select span + span {
  margin-left: 5px;
}
.EditUselectbox_select.border {
  border: 1px solid var(--line-base);
}
.EditUselectbox_list {
  max-height: 180px;
  border: 1px solid var(--line-base);
  overflow: auto;
  position: absolute;
  z-index: 5;
  max-width: 500px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.EditUselectbox_item {
  width: 100%;
  height: 30px;
  display: grid;
  align-content: center;
  justify-content: center;
  background-color: var(--bg-white);
  border-bottom: 1px solid var(--line-guide);
  cursor: pointer;
  color: var(--text-base);
}
.EditUselectbox_item:last-child {
  border-bottom: none;
}
.EditUselectbox_item .select {
  color: var(--active);
}
.EditUselectbox_item:hover {
  color: var(--icon-over);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Uselectbox.vue